import { render } from "./MultiDropdown.vue?vue&type=template&id=23ff4c5b&scoped=true"
import script from "./MultiDropdown.vue?vue&type=script&lang=ts"
export * from "./MultiDropdown.vue?vue&type=script&lang=ts"

import "./MultiDropdown.vue?vue&type=style&index=0&id=23ff4c5b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-23ff4c5b"

export default script